import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

interface CategoryNavProps {
  title: string;
  subtitle: string;
}

export default function CategoryNav({ title, subtitle }: CategoryNavProps) {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            {title}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            {subtitle}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 text-center no-underline"
            >
              <div className="w-12 h-12 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base">
                {cat.name}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500 line-clamp-1">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}